import { render, staticRenderFns } from "./KeyboardAlice.vue?vue&type=template&id=03715c6a&scoped=true&"
import script from "./KeyboardAlice.vue?vue&type=script&lang=js&"
export * from "./KeyboardAlice.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardAlice.vue?vue&type=style&index=0&id=03715c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03715c6a",
  null
  
)

export default component.exports